const pageNameKey = "otaReleaseNotes";

export const otaReleaseNotesEn = {
  [pageNameKey]: {
    improvementsText: "Improvements",
    generalText: "General",
    fixesText: "Fixes",
    releaseNotesHeadText: "Release Notes",
    backupNotesText: "Backup Notes",
    emptyBackupInfoText:
      "This card shows you the information about the latest backup created.",
    emptyFirwareInfoText:
      "The card shows you the information about the latest release uploaded.",
    emptyConfigurationInfoText:
      "The card shows you the information about the latest release uploaded.",
  },
};

export const otaReleaseNotesPtBr = {
  [pageNameKey]: {
    improvementsText: "Melhorias",
    generalText: "Geral",
    fixesText: "Correções",
    releaseNotesHeadText: "Notas da versão",
    backupNotesText: "Notas de backup",
    emptyBackupInfoText:
      "Este cartão mostra as informações sobre o backup mais recente criado.",
    emptyFirwareInfoText:
      "O cartão mostra as informações sobre a versão mais recente enviada.",
    emptyConfigurationInfoText:
      "O cartão mostra as informações sobre a versão mais recente enviada.",
  },
};

export const otaReleaseNotesDe = {
  [pageNameKey]: {
    improvementsText: "Verbesserungen",
    generalText: "Allgemein",
    fixesText: "Fehlerbehebungen",
    releaseNotesHeadText: "Versionshinweise",
    backupNotesText: "Sicherungsnotizen",
    emptyBackupInfoText:
      "Diese Karte zeigt Informationen über das zuletzt erstellte Backup.",
    emptyFirwareInfoText:
      "Diese Karte zeigt Informationen über die zuletzt hochgeladene Version.",
    emptyConfigurationInfoText:
      "Diese Karte zeigt Informationen über die zuletzt hochgeladene Version.",
  },
};

export const otaReleaseNotesZhHans = {
  [pageNameKey]: {
    improvementsText: "改进",
    generalText: "常规",
    fixesText: "修复",
    releaseNotesHeadText: "发行说明",
    backupNotesText: "备份笔记",
    emptyBackupInfoText: "此卡片显示最近创建的备份信息。",
    emptyFirwareInfoText: "此卡片显示最近上传的版本信息。",
    emptyConfigurationInfoText: "此卡片显示最近上传的版本信息。",
  },
};

export const otaReleaseNotesIt = {
  [pageNameKey]: {
    improvementsText: "Miglioramenti",
    generalText: "Generale",
    fixesText: "Correzioni",
    releaseNotesHeadText: "Note di versione",
    backupNotesText: "Note di backup",
    emptyBackupInfoText:
      "Questa carta mostra le informazioni sul backup più recente.",
    emptyFirwareInfoText:
      "La scheda mostra le informazioni sulla versione più recente caricata.",
    emptyConfigurationInfoText:
      "La scheda mostra le informazioni sulla versione più recente caricata.",
  },
};

export const otaReleaseNotesEs = {
  [pageNameKey]: {
    improvementsText: "Mejoras",
    generalText: "General",
    fixesText: "Correcciones",
    releaseNotesHeadText: "Notas de la versión",
    backupNotesText: "Notas de respaldo",
    emptyBackupInfoText:
      "Esta tarjeta te muestra la información sobre la copia de seguridad más reciente creada.",
    emptyFirwareInfoText:
      "La tarjeta te muestra la información sobre la última versión cargada.",
    emptyConfigurationInfoText:
      "La tarjeta te muestra la información sobre la última versión cargada.",
  },
};

export const otaReleaseNotesNl = {
  [pageNameKey]: {
    backupNotesText: "Back-upnotities",
    emptyBackupInfoText:
      "Deze kaart toont u de informatie over de laatst gemaakte back-up.",
    emptyConfigurationInfoText:
      "De kaart toont u de informatie over de laatst geuploaded release.",
    emptyFirwareInfoText:
      "De kaart toont u de informatie over de laatst geuploaded release.",
    fixesText: "Foutoplossingen",
    generalText: "Algemeen",
    improvementsText: "Verbeteringen",
    releaseNotesHeadText: "Release-opmerkingen",
  },
};

export const otaReleaseNotesTr = {
  [pageNameKey]: {
    backupNotesText: "Yedekleme Notları",
    emptyBackupInfoText:
      "Bu kart size oluşturulan en son yedeklemeyle ilgili bilgileri gösterir.",
    emptyConfigurationInfoText:
      "Kart size en son yüklenen sürümle ilgili bilgileri gösterir.",
    emptyFirwareInfoText:
      "Kart size en son yüklenen sürümle ilgili bilgileri gösterir.",
    fixesText: "Düzeltmeler",
    generalText: "Genel",
    improvementsText: "İyileştirmeler",
    releaseNotesHeadText: "Sürüm Notları",
  },
};
